export default function checkChar(checked: boolean): string {
    return checked ? "✔" : "✘";
}
